import { FunctionComponent } from "react";
import ClickableDiv from "../shared/ClickableDiv";

interface IProps {
	id: string;
	isOpen: boolean;
	toggleSideNav(): void;
}

const MenuHamburger: FunctionComponent<IProps> = (props) => {
	const { id, isOpen, toggleSideNav } = props;
	return <ClickableDiv className={"navButton " + (isOpen && "change")} id={id} onClick={toggleSideNav}>
		<div className="bar1"></div>
		<div className="bar2"></div>
		<div className="bar3"></div>
	</ClickableDiv>;
};

export default MenuHamburger;